import React from 'react'
import { Stack, Spinner, Text, SimpleGrid } from '@chakra-ui/react'
import { setLocalAuthDetails } from '../../../utils/common.util'
import { useLanguageContext } from '../../../context/locale.context'
import OrgCard from './orgCard'
import { AUTH_ORGANIZATION_ID } from '../../../utils/constant'
import { useHistory } from 'react-router-dom'
import { useLoadS3Creds } from '../../../hooks/shared.hooks'

export default function OrgList({ orgnizationList, isLoading }) {
	const { mutate: mutateS3Creds } = useLoadS3Creds()

	const currentOrgId = parseInt(localStorage.getItem(AUTH_ORGANIZATION_ID), 10)
	const history = useHistory()
	const {
		state: { locale },
	} = useLanguageContext()

	const navigateTo = org => {
		if (org.organization_id !== currentOrgId) {
			setLocalAuthDetails(org)
			mutateS3Creds({})
			// window.location.reload()
			history.push('/idcardscreen')
		}
	}

	if (isLoading) {
		return (
			<Stack
				my={3}
				p={5}
				justifyContent='center'
				alignItems='center'
				direction='column'
			>
				<Spinner size='lg' />
				<Text color='brand.800'>{locale['Please wait...']}</Text>
			</Stack>
		)
	}
	return (
		<SimpleGrid spacing='1rem' columns={1} m='1.875rem' w='max-content'>
			{(orgnizationList || []).map((org, index) => {
				return (
					<OrgCard
						cardInfo={org}
						onSelect={navigateTo}
						key={index}
						index={index}
					/>
				)
			})}
		</SimpleGrid>
	)
}
